package com.devi3east.bashbuddy.common.service

import kotlinx.serialization.Serializable

@Serializable
data class AppConfigResponse(
    val currentMobileVersion: Int,
    val minimumMobileVersion: Int,
    val leaderboardPromotionEnabled: Boolean = false
)